module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side-x"
  }, [_c('desktop-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main-x",
    staticStyle: {
      "margin-left": "7%"
    }
  }, [_c('div', {
    staticClass: "card crd-header"
  }, [_c('desktop-header', {
    staticStyle: {
      "left": "7%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-desktop-body-x",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Orders")]), _vm._v(" "), _c('component-items')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d7f0608"}!./src/pages/PlacedOrders/desktop/desktop.html
// module id = 588
// module chunks = 0